import React from 'react'

import { SnugAppQueryProvider } from 'components/OnboardingQueryProvider'
import { connect } from 'react-redux'

import SnugOnboardingPageWithAPI from 'app/pages/teams/settings/onboarding/SnugOnboardingPageWithAPI'

// Map Redux state to component props
const mapStateToProps = (state) => {
  // Extract team, user, and agency data from Redux session state
  const currentTeam = state.session?.currentTeam
  const currentUser = state.session?.currentUser
  const currentAgency = state.session?.currentAgency

  return {
    currentTeam,
    currentUser,
    currentAgency,
  }
}

// No actions needed - API mutations handle state updates
const mapDispatchToProps = {}

// Wrapper component that provides both Redux state and QueryClient
const OnboardingPageWithReduxAndQuery = (props) => (
  <SnugAppQueryProvider>
    <SnugOnboardingPageWithAPI {...props} />
  </SnugAppQueryProvider>
)

// Connect the wrapper component to Redux store
const ConnectedOnboardingPageWithAPI = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnboardingPageWithReduxAndQuery)

export default ConnectedOnboardingPageWithAPI
